export default () => ({
	creating: {
		loading: [],

		// clientType helper
		// We need to keep track of client type when we are creating a policy manually
		clientType: "individual"
	},

	listing: {
		loading: [],

		// What page we are on
		page: 1,

		// How many items is in database
		numberOfItems: 0,

		// How many items per page
		itemsPerPage: null,

		// Sort info - what prop we sort and whether it's asc/desc
		sorting: [],

		// Search - search term for searching of policies
		searchTerm: null,

		// Filter - filter info
		filter: {
			isFiltering: false,
			payload: null, // payload of filter form
			where: null // processed payload into where param of graphql query
		},

		// Fetched items from backend
		list: []
	},

	detail: {
		loading: [],
		data: {},
		benefitInfos: []
	},

	updating: {
		loading: []
	},

	deleting: {
		loading: []
	}
})
